import { render } from "./Queries.vue?vue&type=template&id=2af9d0a0"
import script from "./Queries.vue?vue&type=script&lang=js"
export * from "./Queries.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\DD6576\\tourbillon-timescale\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__